<template>
  <v-dialog v-model="telcoTransfer" width="500">
    <v-card>
      <v-card-title>Porting {{ getProductId }} to bOnline VoIP</v-card-title>

      <v-card-text>
        <v-row><v-col>Please enter the ID of the VoIP product to link {{ getProductId }} to:</v-col></v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="product_id" outlined dense required :error-messages="productId" @input="$v.product_id.$touch()" @blur="$v.product_id.$touch()" label="Product ID" class="mb-n6"></v-text-field>
          </v-col>
        </v-row>
        <v-row><v-col class="error--text">Pressing “Transfer” will move the telco product <b>{{ getProductId }}</b> into the “Transfer Out” status</v-col></v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small :disabled="$v.$invalid || getIsCreateLinkedProductLoading" :loading="getIsCreateLinkedProductLoading" @click.prevent="submit(currentProduct.lead_id, product_id)">Transfer</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="reset()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  validations: { product_id: { required, numeric } },

  props: {
    telcoTransfer: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      product_id: "",
      lead: this.$route.params.id,
    }
  },

  computed: {
    ...mapState("products", ["currentProduct"]),
    ...mapGetters("productLinks", ["getIsCreateLinkedProductLoading", "getIsCreateLinkedProductError", "getIsCreateLinkedProductErrorResponse"]),

    productId() {
      const errors = [];
      if (!this.$v.product_id.$dirty) return errors;
      !this.$v.product_id.required && errors.push("Product ID is required");
      !this.$v.product_id.numeric && errors.push("Product ID must be numeric");
      return errors;
    },

    getProductId() {
      return this.currentProduct.lead_id || this.lead;
    }
  },

  methods: {
    ...mapActions("productLinks", ["createLinkedProduct", "fetchLinkedProduct"]),
    ...mapActions("alerts", ["setAlert"]),

    async submit(lead_id, product_id) {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const payload = { product_2_id: product_id, link_type: "INTERNAL_TRANSFER" };

        await this.createLinkedProduct({ lead_id, payload });

        if(!this.getIsCreateLinkedProductError) {
          this.reset();
        }
      }
    },

    reset() {
      this.product_id = "";
      this.$emit('close-transfer');
    }
  }
}
</script>

<style>

</style>
